import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { routeFns } from "../../routePaths.js";
import type { DefaultPageProps } from "../defaultProps.js";
import { PatientSearch as PatientPageV2 } from "../PatientSearchV2/PatientSearch.js";
import { PatientCreateEdit } from "./PatientCreateEdit.js";

export function PatientPage({}: DefaultPageProps) {
  return <PatientPageV2 />;
}

export function PatientCreatePage({}: DefaultPageProps) {
  const [patientCreateState, setPatientCreateState] = useState<null>(null);
  const navigate = useNavigate();
  return (
    <PatientCreateEdit
      mode={"create"}
      initialState={patientCreateState}
      exitPatientCreate={() => {
        setPatientCreateState(null);
        return navigate(routeFns.patientSearch());
      }}
    />
  );
}
